import { createBrowserClient } from "@supabase/ssr";

// @supabase/ssr's createBrowserClient already writes/reads cookies via
// document.cookie, including chunked sb-<ref>-auth-token.0/.1/.N for
// JWTs that exceed a single cookie's size. Do NOT pass a custom
// cookies config here — overriding it skips the chunking and the
// session becomes unreadable on reload.
export function createClient() {
  return createBrowserClient(
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_SUPABASE_ANON_KEY,
  );
}

export const supabase = createClient();
